<template>
    <div>
        <div class="containerfull"></div>
  <div class="container">
    <div class="wrapper">
      <div class="main">
        <router-link to="/">
          <div class="logo">
            <img :src="$store.state.config.shop_logo" alt>
          </div>
        </router-link>
        <div class="title">注册{{$store.state.config.shop_name}}账号</div>
        <div class="register-form">
          <code-input
            @getTelPhone="getPhoneValue"
            @getInputError="getInputError"
            @getSmsCode="getSmsCode"
            @getJob="getJobValue"
            @getNickName="getNickName"
          ></code-input>
          <div class="input-group">
            <i class="icon iconfont iconpassword"></i>
            <input
              placeholder="请输入密码"
              v-model="password"
              class="reg-input password"
              :type="showPassword?'text':'password'"
            >
            <i
              class="icon iconfont"
              :class="showPassword?'iconpassword-view':' iconpassword-not-view'"
              @click="changeInputType"
            ></i>
          </div>
          <div class="error" v-show="showError">
            <i class="icon iconfont iconerror"></i>
            {{errorText}}
          </div>
          <div class="register-btn" @click="handleRegister">注册</div>
          <div class="tologin">
            <router-link :to="'login'">已有账号？去登录</router-link>
          </div>
        </div>
        <div class="tip">
          <label for="agree" class="labind" @click="checked=!checked">
            <i class="icon iconfont" :class="checked?'iconradioed':'iconradio'"></i>
            注册帐号即表示您同意并愿意遵守展特易商城
            <a href="javascript:;">用户协议</a>和
            <a href="javascript:;">隐私政策</a>
          </label>
        </div>
      </div>
    </div>
<!--    <CopyRight></CopyRight>-->
  </div>
        </div>
</template>

<script>
import LoginInputGroup from "@/components/login/LoginInputGroup.vue";
// import CopyRight from "@/components/common/CopyRight.vue";
import { inputCheckPhone, isValid } from "@/utils/index.js";
import { mapActions } from "vuex";
export default {
  name: "Register",
  components: {
    "code-input": LoginInputGroup,
    // CopyRight
  },
  props: {},
  data() {
    return {
      telphone: "",
      password: "",
      smsCode: "",
      errorText: "",
      checked: true,
      job:"",
      showPassword: false,
      nickname:"",
    };
  },
  watch: {},
  computed: {
    showError() {
      return isValid(this.errorText);
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    changeInputType() {
      this.showPassword = !this.showPassword;
    },
    handleRegister() {
      if (!this.checked) {
        return (this.errorText = "请您同意用户条款");
      }
      if(!this.job){
        return (this.errorText = "请选择您的角色");
      }
      if(!this.nickname){
        return (this.errorText = "请输入昵称或企业名称");
      }
      if (this.checkInputPhone() && this.checkInputCode()) {
        let data = {
          mobile: this.telphone,
          code: this.smsCode,
          password: this.password,
          platform: 5,
          type:this.job,
          nickname:this.nickname
        };
        this.$api.smsLogin(data).then(res => {
          if (res.status) {
            this.$msg("注册成功！");
            this.$storage.set("userToken", res.data);
            this.$api.userInfo({}).then(result => {
              if (result.status) {
                this.getUserInfo(result.data);
                this.$storage.set("userInfo", result.data);
              }
            });
            this.$router.go(-1);
          } else {
            this.errorText = res.msg;
          }
        });
      }
    },
    checkInputPhone() {
      if (!isValid(this.telphone)) {
        this.errorText = "手机号不能为空";
        return false;
      } else if (!inputCheckPhone(this.telphone)) {
        this.errorText = "手机号格式不正确";
        return false;
      }
      this.errorText = "";
      return true;
    },
    checkInputPassword() {
      if (!isValid(this.password)) {
        this.errorText = "请输入密码";
        return false;
      }
      return true;
    },
    checkInputCode() {
      if (!isValid(this.smsCode)) {
        this.errorText = "请输入验证码";
        return false;
      }
      return true;
    },
    //获取子组件手机号
    getPhoneValue(val) {
      this.telphone = val;
    },
    getNickName(val){
      this.nickname = val;
    },
    //获取子组件手机号
    getJobValue(val) {
      this.job = val;
    },
    //获取子组件验证码
    getSmsCode(val) {
      this.smsCode = val;
    },
    //获取错位信息
    getInputError(val) {
      this.errorText = val;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.containerfull{
    position:fixed;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image:url("~@/assets/image/zhuce.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
.container {
  // position: relative;

  .wrapper {
    width: 801px;
    height: 550px;
    // margin: 0 auto;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
      z-index: 3;
    margin-top: -275px;
    margin-left: -400px;
    .main {
      padding: 40px 0;
      box-sizing: border-box;
        background: #fdfdfd;
        border: 1px solid #00000014;
        box-shadow: 5px 15px 10px 0px;

      .logo {
        height: 60px;
        margin: 0 auto;
        img {
          display: block;
          width: auto;
          height: 100%;
          margin: 0 auto;
          object-fit: contain;
        }
      }
      .title {
        margin-top:10px;
        text-align: center;
        @include line-height(30px);
        font-size: 21px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.register-form {
  width: 312px;
  margin: 35px auto 0;
  .input-group {
    width: 100%;
    height: 40px;
    margin-bottom: 16px;
    border: 1px solid rgba(220, 220, 220, 1);
    border-radius: 0;
    display: flex;
    align-items: center;
    padding: 5px 0 5px 10px;
    box-sizing: border-box;
    .icon {
      display: inline-block;
      text-align: center;
      margin-right: 6px;
    }
    .reg-input {
      display: block;
      height: 100%;
      flex: 1;
    }
    .code-btn {
      width: 84px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #ea4b49;
      font-weight: 400;
      border-left: 1px solid rgba(220, 220, 220, 1);
    }
  }

  .register-btn {
    width: 312px;
    height: 40px;
    line-height: 40px;
    background: #ea4b49;
    color: #fff;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    margin-top: 30px;
  }
  .tologin {
    font-size: 12px;
    text-align: right;
    line-height: 20px;
    margin: 5px 0;
    a {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .error {
    font-size: 12px;
    color: $theme-color;
    transition: all 0.2s;
  }
}
.tip {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  padding-left: 5px;
  margin-bottom: 40px;
  text-align: center;
  padding-top: 40px;
  .labind {
    display: inline-block;
    padding: 10px 0;
    cursor: pointer;
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 3px;
      margin-top: -3px;
      display: inline-block;
      vertical-align: middle;
      font-size: 24px;
      &.iconradioed {
        color: $theme-color;
      }
    }
    a {
      color: #333;
      font-weight: 550;
    }
  }
  .tologin {
    position: absolute;
    right: 0;
    top: 20px;
      z-index: 2;
    color: #4995e3;
    font-size: 10px;
  }
}
.copyright-wrap {
  width: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
    z-index: 2;
}
</style>